import { Injectable } from '@angular/core';
import { CommonService } from '../../commons/services/common.service';

@Injectable()
export class GestionBsdd {
    public static printBSDDMouv(clefMouvCourantArg, common: CommonService)  {
        // const clefMouvCourant = '' + clefMouvCourantArg;
        /*const param = {
            'servlet': 'DBImprimeBSDI',
            'module': 'Recylog',
            'type': 'liste',
            'compression': 'false',clefMouvCourantArg
            'pathImpression': 'Recylog/tmp/BSDD/',
            'data': [
                ['DBImprimeBSDI'],
                [{
                    'typeParam': 'string',
                    'valeur': clefMouvCourant
                }],
                {
                    'typeParam': 'boolean',
                    'valeur': 'true'
                }
            ]
        };*/

        const param = {
            'servlet': 'DBImprimeBSDI',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'pathImpression': 'Recylog/tmp/BSDD/',
            'data': {
                'IS_MERGE': {
                    'typeParam': 'boolean',
                    'valeur': true
                },
                'LISTE_CLEF_MOUV': clefMouvCourantArg,
                'IS_IMPRIMER_BSD_MANUEL': {
                    'typeParam': 'boolean',
                    'valeur': 'true'
                }
            }
        };

        return common.post('', { param: param });
    }

    public static getUrlBsdd(data) {
        const path = data.URL;
        const file = data.LISTE[0][0];
        return path + '' + file;
    }
    
    /*
    public static getUrlBsddForMerge(data) {
        const path = data.URL;
        
        const listURLBSDD = [];
        data.LISTE.forEach(e => {
            listURLBSDD.push(path + '' + e.PDF);
        });

        return listURLBSDD;
    }
    */

    // Impression ADR depuis planning du chauffeur
    public static mergeFilePDF(LIST_FICHIERS, common: CommonService, nom, isNotImprimer?) {
        const param = {
            'servlet': 'DBGestionAngular',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'pathImpression': 'Recylog/tmp',
            'data': {
                'OPERATION': {
                    'typeParam': 'int',
                    'valeur': 22
                },
                'NOM_FICHIER_MERGE': common.user[0] + '_' + nom + '_' + common.getTimestamp() + '.pdf',
                'LIST_FICHIERS': LIST_FICHIERS
            }
        };

        return common.post('', { param: param }, true);
    }    
}
